// extracted by mini-css-extract-plugin
export default {"closeButton":"_0aYKV0G1--ModalKitCloseButton_closeButton__eCnE1","wiggle":"_0aYKV0G1--ModalKitCloseButton_wiggle__w0Wck","shimmer":"_0aYKV0G1--ModalKitCloseButton_shimmer__o1tkS"};